<section class="plan-change-settings" aria-labelledby="plan-change-settings-title">
  <div class="plan-change-settings__loading" *ngIf="isLoading">
    Loading membership plan change settings...
  </div>

  <ng-container *ngIf="!isLoading">
    <h4 id="plan-change-settings-title" class="plan-change-settings__title">
      Membership plan changes
    </h4>

    <div class="plan-change-settings__body">
      <label class="plan-change-settings__toggle-row">
        <span class="plan-change-settings__toggle">
          <input
            type="checkbox"
            class="plan-change-settings__toggle-input"
            role="switch"
            [checked]="settings.enabled"
            [disabled]="isInteractionDisabled"
            [attr.aria-checked]="settings.enabled"
            aria-label="Allow attendants to upgrade or downgrade a membership"
            (change)="onToggleEnabled()"
          />
          <span class="plan-change-settings__toggle-track" aria-hidden="true"></span>
        </span>
        <span class="plan-change-settings__toggle-text">
          <span class="plan-change-settings__label"
            >Allow attendants to upgrade or downgrade a membership</span
          >
          <span class="plan-change-settings__hint">
            Shows Update Membership on the Active Subscription screen for every attendant and admin.
            Charges and refunds are prorated for the rest of the cycle.
          </span>
        </span>
        <span class="plan-change-settings__status" *ngIf="isSaving">Saving...</span>
      </label>

      <p class="plan-change-settings__notice" *ngIf="!globallyEnabled">
        Not yet switched on for this environment by Way. Your setting is saved and takes effect when
        it is.
      </p>

      <div class="plan-change-settings__locations" *ngIf="settings.enabled">
        <p class="plan-change-settings__subtitle">Locations</p>

        <p class="plan-change-settings__hint" *ngIf="!locations.length">
          No active locations found.
        </p>

        <div class="plan-change-settings__location-list" *ngIf="locations.length">
          <label
            class="plan-change-settings__location"
            *ngFor="let location of locations; trackBy: trackLocation"
            [class.plan-change-settings__location--on]="
              !isRestrictedToLocations || isLocationSelected(location.id)
            "
          >
            <input
              type="checkbox"
              class="plan-change-settings__checkbox"
              [checked]="!isRestrictedToLocations || isLocationSelected(location.id)"
              [disabled]="isInteractionDisabled"
              (change)="onToggleLocation(location.id)"
            />
            <span>{{ locationLabel(location) }}</span>
          </label>
        </div>

        <div class="plan-change-settings__location-actions">
          <ng-container *ngIf="isRestrictedToLocations; else unrestricted">
            <button
              type="button"
              class="plan-change-settings__link"
              [disabled]="isInteractionDisabled"
              (click)="onAllowEveryLocation()"
            >
              Allow every location
            </button>
          </ng-container>
          <ng-template #unrestricted>
            <span class="plan-change-settings__hint"
              >On at every location. Untick a location to turn it off there.</span
            >
          </ng-template>
        </div>
      </div>
    </div>
  </ng-container>
</section>
